import type { CalendarRenewalDto } from '@bhops/shared';

// 재계약 일정의 칩 · 목록 표기(2026-10-22) — 통합 캘린더와 '다가오는 일정'이 같은 말을 쓴다.

/** '팔만식당 → 팔만식당[26년 10월]'. */
export function renewalTitle(r: CalendarRenewalDto): string {
  return `${r.fromCustomerName} → ${r.toCustomerName}`;
}

/** '회수 #951 · 이어서 사용 #952 · 설치 #921' — 마쳤으면 앞에 '재계약 완료 · '. 새 로봇이 아직이면 '설치 배정 전'. */
export function renewalSubtitle(r: CalendarRenewalDto): string {
  const returns = r.robots.filter((x) => x.action === 'RETURN').map((x) => x.label);
  const carries = r.robots.filter((x) => x.action === 'CARRY').map((x) => x.label);
  const parts = [
    ...(returns.length ? [`회수 ${returns.join(', ')}`] : []),
    ...(carries.length ? [`이어서 사용 ${carries.join(', ')}`] : []),
    r.incoming.length
      ? `설치 ${r.incoming.map((x) => x.label).join(', ')}`
      : r.done
        ? null
        : '설치 배정 전',
  ].filter(Boolean);
  return `${r.done ? '재계약 완료 · ' : ''}${parts.join(' · ')}`;
}
